import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'
import { IMultiBankPosInsatallment } from '../models/models'

export class AddMultiBankParamPosInsatallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransactionParam/addMultiBankParamPosInsatallment',
      requesterInfo,
    })
  }

  public async addMultiBankParamPosInsatallment(request: IMultiBankPosInsatallment): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(request)
  }
}
